import { IVersion } from '@/contracts/modules/note/entities/IVersion'
import { IDocument } from '@/contracts/modules/note/entities/IDocument'

export class Version implements IVersion {
  constructor(private time: string, private content: IDocument) {}

  getTime(): string {
    return this.time
  }

  getContent(): IDocument {
    return this.content
  }
}
